import ListItem from "~/types/ListItemType";

export function removeObjectById(list: Array<ListItem>, id: Number) {
  return list.filter((listItem) => listItem.id !== id);
}
